module.exports = __webpack_public_path__ + "img/small_whale32.9eb71bc0.jpg";